var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.titleObj.showDate
      ? _c(
          "div",
          [
            _vm.dateArr.length < 2
              ? _c("div", { staticClass: "text-59" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm
                          .$t(_vm.dateArr[0].tip, [_vm.titleObj.attributeName])
                          .d(_vm.dateArr[0].tipText)
                      ) +
                      "\n    "
                  ),
                ])
              : _c(
                  "yxtf-dropdown",
                  {
                    staticClass:
                      "yxtbiz-rank__rank-title-dropdown cursor-point",
                    attrs: { trigger: "click" },
                    on: { command: _vm.handleDateChange },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t(_vm.activeDate.label).d(_vm.activeDate.text)
                        ) +
                        "\n      "
                    ),
                    _c(
                      "yxtf-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      _vm._l(_vm.dateArr, function (item, index) {
                        return _c(
                          "yxtf-dropdown-item",
                          {
                            key: index,
                            class: {
                              "color-primary-6-i":
                                item.type === _vm.titleObj.defaultDateType,
                            },
                            attrs: { command: item },
                          },
                          [_vm._v(_vm._s(_vm.$t(item.label).d(item.text)))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }